// extracted by mini-css-extract-plugin
module.exports = {"rotation":"HomeTemplate_rotation__66Vq_"};